<template>
	<div class="hd-mod-frame-many-molecule">
		<!-- Main Molecule -->
		<div 
			:class="[
				'hd-mod-frame-many-molecule__main main hd-mod-frame-many-molecule__element',
				'js-mod-frame-many-molecule-main js-mod-frame-many-molecule-element'
			]" 
		/>

		<!-- Background Faces -->
		<div 
			:class="[
				'hd-mod-frame-many-molecule__secondary face-1 hd-mod-frame-many-molecule__element',
				'js-mod-frame-many-molecule-face-1 js-mod-frame-many-molecule-element'
			]" 
		/>
		<div 
			:class="[
				'hd-mod-frame-many-molecule__secondary face-2 hd-mod-frame-many-molecule__element',
				'js-mod-frame-many-molecule-face-2 js-mod-frame-many-molecule-element'
			]" 
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-frame-many-molecule {
		@include absolute-lr-0();
		@include box(100%);

		&__main {
			@include absolute-center-y();
			left: 35%;
			@include box(320px);
			background: url('../../assets/images/mod-sars-mol.png');
			@include background-contain();
		}

		&__secondary {
			@include absolute-lr-0();
			@include box(100%);

			&.face-1 {
				background: url('../../assets/images/03-mod-frame-many-molecules-1.png');
				@include background-contain();
			}

			&.face-2 {
				background: url('../../assets/images/03-mod-frame-many-molecules-2.png');
				@include background-contain();
			}
		}

		&__element {
			opacity: 0;
			transition: all 1s ease;

			// Animation 
			&[data-state="animation-ready"] {
				&.main {
					@include animation-frame-fade-in();
					animation-delay: 0.5s;
				}
				&.face-1 {
					@include animation-frame-enter-across-br();
				}
				&.face-2 {
					@include animation-frame-enter-across-tl();
				}
			}

			&[data-state="animation-leave"] {
				@include animation-frame-fade-out();
			}
		}

		// Responsive
		@include res-screen-small {
			&__main {
				@include box(250px);
			}
		}

		@include res-screen-x-small {
			&__main {
				@include box(220px);
			}
		}

		@include res-screen-portrait-sm {
			&__main {
				@include box(120px);
			}
		}
	}
</style>